import "bootstrap/dist/css/bootstrap.min.css";
import "../App.css";
import {
    AppBar,
    Box,
    Button,
    createTheme,
    Drawer,
    IconButton,
    List,
    ListItem,
    ThemeProvider,
    Toolbar,
    Typography
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';

import React, {useState} from "react";
import {useLanguage} from "../LanguageContext";
import FooterLogo from "./footer/FooterLogo";
import LanguageSwitcher from "./language/LanguageSwitcher";

import logo from "../images/logo/logo3.png";
import {useNavigation} from "../NavigationProvider";
import TopMenuLanguageSwitcher from "./language/TopMenuLanguageSwitcher";


const theme = createTheme({
        typography: {
            fontFamily: "'Roboto', 'Arial', sans-serif",
            h5: {
                fontFamily: 'Jost-Regular',
                fontSize: '1rem',
                '@media (min-width:600px)': {
                    fontSize: '1.5rem',
                },
            },
        },
        components: {
            MuiButton: {
                styleOverrides: {
                    root: {
                        fontFamily: 'Jost-Regular',
                        borderRadius: '8px',
                        padding: '0px 8px',
                        fontSize: '1rem',
                        color: '#ffffff',
                        letterSpacing: '1.5px'
                    },
                    contained: {
                        boxShadow: 'none',
                        '&:hover': {
                            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
                        },
                    },
                    outlined: {
                        borderWidth: '2px',
                    },

                },
            },
            MuiTypography: {
                styleOverrides: {
                    root: {
                        marginBottom: '16px',
                    },
                },
            },
            MuiPaper: {
                styleOverrides: {
                    root: {
                        padding: '4px',
                    },
                },
            },
            MuiAppBar: {
                styleOverrides: {
                    root: {
                        backgroundColor: '#1976d2',
                        color: '#ffffff',
                    },
                },
            },
            MuiTextField: {
                styleOverrides: {
                    root: {
                        margin: '8px 0',
                        '& .MuiOutlinedInput-root': {
                            borderRadius: '8px',
                        },
                    },
                },
            },
        },

    })
;

export const menuItems = [
    {label: 'label_main', path: '/'},
    {label: 'label_destinations', path: '/destinations'},
    {label: 'label_way_to_explore', path: '/way-to-explore'},
    // {label: 'label_faq', path: '/faq'},
];

const TopMenu = () => {
    const {t} = useLanguage();
    const [drawerOpen, setDrawerOpen] = useState(false);
    const {handleNavigation} = useNavigation();

    const toggleDrawer = (open) => () => {
        setDrawerOpen(open);
    };

    return (
        <ThemeProvider theme={theme}>
            <AppBar
                position="static"
                elevation={0}
                disableScrollLock={true}
                sx={{
                    border: 0,
                    // backgroundColor: "",
                    backgroundColor: {
                        xs: 'rgba(41,54,44,0)',
                        md: '#29362C',
                    },
                    backdropFilter: {xs: "none", md: "blur(10px)"},
                    WebkitBackdropFilter: {xs: "none", md: "blur(10px)"},
                }}
            >
                <Toolbar
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        height: "76px",
                        minHeight: "76px",
                        "@media (min-width:600px)": {
                            minHeight: "76px ",
                            maxHeight: "76px ",
                        },
                    }}
                >
                    <Box
                        onClick={() => handleNavigation('/')}
                        sx={{
                            display: {xs: "none", md: "flex"},
                            height: 30,
                            width: "auto",
                            // marginRight: "auto",
                            marginLeft: "10px",
                            zIndex: 10,
                        }}>
                        <Box
                            component="img"
                            src={logo}
                            alt="Logo"
                        />
                    </Box>


                    {/* Menu (centered using flex-grow) */}
                    <Box
                        sx={{
                            display: {xs: "none", md: "flex"},
                            gap: "16px",
                            flexGrow: 1, // Allows centering
                            justifyContent: "center",
                            height: '48px',
                            // marginLeft: "80px",
                        }}
                    >
                        {menuItems.map((item, index) => (
                            <Button key={index} color="inherit" onClick={() => handleNavigation(item.path)} sx={{
                                paddingTop: '12px',
                            }}>
                                <Typography
                                    sx={{
                                        fontSize: '18px',
                                        fontFamily: 'Jost-Regular',
                                    }}
                                >{t(item.label)}</Typography>
                            </Button>
                        ))}
                    </Box>
                    <Box
                        sx={{
                            display: {
                                xs: 'none',
                                md: 'block'
                            }
                        }}
                    >
                        <TopMenuLanguageSwitcher/>
                    </Box>

                    {/* Mobile menu button (right) */}
                    <IconButton
                        color="inherit"
                        edge="end"
                        onClick={toggleDrawer(true)}
                        sx={{
                            display: {xs: "block", md: "none"},
                            width: 50,
                            height: 50,
                            backgroundColor: "rgba(0, 0, 0, 0.5)",
                            borderRadius: "50%",
                            position: "absolute",
                            right: 16,
                            top: "50%",
                            transform: "translateY(-50%)",
                        }}
                    >
                        <MenuIcon
                            sx={{
                                position: "absolute",
                                right: 10,
                                top: 12,
                                width: "30px",
                                height: "30px",
                            }}
                        />
                    </IconButton>
                </Toolbar>
            </AppBar>


            <Drawer
                anchor="right"
                open={drawerOpen}
                onClose={toggleDrawer(false)}
                PaperProps={{
                    sx: {
                        width: '100%',
                        backgroundColor: "#29362C",
                    }
                }}
            >
                <Box
                    role="presentation"
                    sx={{
                        height: '100vh',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        textAlign: 'center',
                    }}
                    onClick={toggleDrawer(false)}>

                    <List
                        sx={{
                            width: '70%',
                            display: 'flex',
                            flexDirection: 'column',
                            marginLeft: '30%',
                            alignItems: 'left',
                            justifyContent: 'left',
                        }}
                    >
                        {menuItems.map((item, index) => (
                            <ListItem key={index}>
                                <Button
                                    sx={{
                                        width: '100%',
                                        textAlign: 'left',
                                        justifyContent: "flex-start"
                                    }}
                                    key={index}
                                    onClick={() => handleNavigation(item.path)}>
                                    {t(item.label)}
                                </Button>
                            </ListItem>
                        ))}
                    </List>

                    <Box
                        sx={{
                            position: 'absolute',
                            bottom: '80px',
                        }}
                    >
                        <FooterLogo/>
                    </Box>

                    <Box
                        sx={{
                            position: 'absolute',
                            top: '20px',
                            left: '20px',
                            color: 'white',
                            fontFamily: 'Jost-Regular',
                            letterSpacing: '1px'

                        }}
                    >
                        <Typography variant="h5">Art Rendezvous</Typography>
                    </Box>
                    <Box
                        sx={{
                            position: 'absolute',
                            bottom: 20,
                        }}>
                        <LanguageSwitcher/>
                    </Box>
                </Box>
            </Drawer>

        </ThemeProvider>
    );
};

export default TopMenu;
